import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const LocalPinIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 21" {...props}>
            <path
                d="M16.5 8.71567C16.5 13.8066 10 18.1702 10 18.1702C10 18.1702 3.5 13.8066 3.5 8.71567C3.5 6.9797 4.18482 5.31484 5.40381 4.08733C6.62279 2.85982 8.27609 2.17021 10 2.17021C11.7239 2.17021 13.3772 2.85982 14.5962 4.08733C15.8152 5.31484 16.5 6.9797 16.5 8.71567Z"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.05 10.1702C11.2927 10.1702 12.3 9.16285 12.3 7.92021C12.3 6.67757 11.2927 5.67021 10.05 5.67021C8.80741 5.67021 7.80005 6.67757 7.80005 7.92021C7.80005 9.16285 8.80741 10.1702 10.05 10.1702Z"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
